import { useNavigate } from 'react-router-dom';
import GetStartedFreeTrial from '../../components/GetStartedFreeTrial';
import { useEffect, useState } from 'react';

const customContent = [
    {
        image: "./images/real-time-tracking.jpg",
        title: "Real-Time Fleet & Vehicle Tracking",
        description:
            "Track vehicle location, usage, and availability in real time with built-in fleet tracking software. Improve route planning, reduce downtime, and ensure smooth pickups and returns."
    },
    {
        image: "./images/automated-reservation-system.png",
        title: "Automated Vehicle Booking & Reservation System",
        description:
            "Manage online bookings, vehicle availability, pricing, and confirmations with an automated reservation system built for rental businesses. Eliminate double bookings and manual errors."
    },
    {
        image: "./images/maintenance-rd-rental.jpg",
        title: "Vehicle Maintenance & Service Management",
        description:
            "Stay on top of fleet maintenance with automated service reminders, maintenance history, and alerts. Reduce breakdowns and keep every vehicle rental-ready at all times."
    },
];

const appScreens = [
    {
        image: "/images/rental-home.png",
        title: "Stay on Schedule",
    },
    {
        image: "/images/rental-reservations.png",
        title: "Reservations",
    },
    {
        image: "/images/rental-checkout.png",
        title: "Check Out",
    },
    {
        image: "/images/rental-signature.png",
        title: "Digital Signatures",
    },
    {
        image: "/images/rental-checkin.png",
        title: "Check In",
    },
    {
        image: "/images/rental-fleet.png",
        title: "Fleet Management"
    },
];

const Home = () => {
    const navigate = useNavigate();

    const [activeScreen, setActiveScreen] = useState<number>(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveScreen(
                (current) => (current + 1) % appScreens.length
            );
        }, 4000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div>
            <section style={{ position: 'relative', height: '100vh', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', inset: 0, backgroundColor: '#000', opacity: 1 }}></div>
                <div style={{ position: 'absolute', inset: 0, backgroundColor: 'black', opacity: 0.3 }}>
                    <img
                        style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center' }}
                        src="../images/home-section-rd-rental.jpg"
                        // pexels.com
                        alt="Hero Section Background"
                    />
                </div>
                <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ textAlign: 'center', color: 'white', zIndex: 10, position: 'relative' }}>
                        <h1 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1rem' }}>Vehicle Rental Management Software Built to Scale Your Business</h1>
                        <p style={{ fontSize: "1.2rem", maxWidth: "800px", margin: "0 auto 2rem" }}>
                            RD Rental is a vehicle rental management SaaS that helps your business to grow fast and easy.
                        </p>

                        <button
                            style={{
                                backgroundColor: '#ffffff',
                                color: 'black',
                                fontWeight: 'bold',
                                padding: '0.75rem 1.5rem',
                                borderRadius: '0.5rem',
                                border: 'none',
                                cursor: 'pointer',
                                transition: 'all 0.3s',
                            }}
                            onClick={() => navigate("/free-trial")}
                            onMouseOver={(e) => {
                                const button = e.target as HTMLButtonElement;
                                button.style.backgroundColor = 'black';
                                button.style.color = 'white';
                            }}
                            onMouseOut={(e) => {
                                const button = e.target as HTMLButtonElement;
                                button.style.backgroundColor = '#ffffff';
                                button.style.color = 'black';
                            }}
                        >
                            Get Started
                        </button>
                    </div>
                </div>
            </section>

            <section style={{ padding: '4rem 0', backgroundColor: 'white', color: 'black' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>
                    <h2 style={{ fontSize: '2rem', fontWeight: 'bold', textAlign: 'center', marginBottom: '2rem' }}>Why Choose RD Rental Vehicle Rental Management Software?</h2>
                    <p style={{ fontSize: '1rem', textAlign: 'center' }}>
                        RD Rental is designed specifically for car, van, and fleet rental businesses looking to automate operations
                        and eliminate manual work. From managing reservations and vehicle availability to tracking maintenance,
                        billing customers, and generating reports — everything is handled in one easy-to-use platform.
                    </p>
                </div>
            </section>

            <section style={{ padding: '4rem 0', backgroundColor: '#f3f4f6' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>
                    <h2 style={{ fontSize: '2rem', fontWeight: 'bold', textAlign: 'center', color: '#4a5568', marginBottom: '2rem' }}>Powerful Features for Rental Businesses</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
                        {customContent.map((content, index) => (
                            <div key={index} style={{ backgroundColor: 'white', borderRadius: '0.5rem', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', overflow: 'hidden' }}>
                                <div style={{ position: 'relative' }}>
                                    <img
                                        style={{ width: '100%', height: '12rem', objectFit: 'cover', objectPosition: 'center' }}
                                        src={content.image}
                                        alt="car rental management software feature"
                                    />
                                </div>
                                <div style={{ padding: '1.5rem' }}>
                                    <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem' }}>{content.title}</h3>
                                    <p style={{ color: '#718096' }}>{content.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section
                id="mobile-app"
                className="relative overflow-hidden bg-[#e1f4fc] py-20 lg:py-24"
            >
                <div className="mx-auto max-w-7xl px-6">
                    <div className="grid items-center gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-6">
                        <div className="relative z-10">
                            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/80 bg-white/70 px-4 py-2 text-sm font-semibold text-[#1685c4] shadow-sm backdrop-blur-md">
                                <span className="h-2 w-2 rounded-full bg-[#1685c4]" />
                                <span>RD Rental Mobile App</span>
                            </div>

                            <h2 className="different_heading text-[44px] font-semibold leading-[1] text-black lg:text-[64px]">
                                <span>One Platform For</span>
                                <br />

                                <span className="italic text-secondary">
                                    Rental Vehicle
                                </span>
                            </h2>

                            <p className="mt-8 max-w-xl text-lg leading-8 text-[#334155]">
                                Simplify rental vehicle management with powerful tools
                                designed to help your rental company stay organized,
                                connected, and efficient.
                            </p>

                            <p className="mt-4 max-w-xl text-lg leading-8 text-[#334155]">
                                Manage reservations, vehicles, pickups, returns,
                                signatures, and fleet operations from one centralized
                                mobile platform.
                            </p>

                            <div className="mt-10 flex flex-wrap items-center gap-4">
                               
                                <a
                                    href="https://apps.apple.com/us/app/rd-rental/id6795705852"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src="/images/apple-store-badge.png"
                                        alt="Download on the App Store"
                                        className="h-14 w-auto sm:h-16"
                                    />
                                </a>

                                <a
                                    href="https://play.google.com/store/apps/details?id=com.datarepo.rdrental&hl=en_US"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src="/images/google-play-badge.png"
                                        alt="Get it on Google Play"
                                        className="h-14 w-auto sm:h-16 transition-transform hover:scale-105 duration-300"
                                    />
                                </a>
                            </div>
                        </div>

                        <div className="relative h-[600px] w-full sm:h-[680px]">
                            <div className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#1685c4]/20 blur-[100px]" />

                            <div className="absolute inset-0 hidden items-center justify-center lg:flex">
                                {
                                    appScreens.map((screen, index) => {
                                        const position = (index - activeScreen + appScreens.length) % appScreens.length;
                                        const isActive = position === 0;
                                        const isPrevious = position === appScreens.length - 1;
                                        const isNext = position === 1;

                                        let transform = "";
                                        let opacity = 0;
                                        let zIndex = 0;
                                        let width = "220px";

                                        if (isActive) {
                                            transform = "translateX(0) scale(1)";
                                            opacity = 1;
                                            zIndex = 30;
                                            width = "320px";
                                        } else if (isPrevious) {
                                            transform = "translateX(-150px) scale(0.78) rotate(-5deg)";
                                            opacity = 0.55;
                                            zIndex = 20;
                                            width = "235px";
                                        } else if (isNext) {
                                            transform = "translateX(150px) scale(0.78) rotate(5deg)";
                                            opacity = 0.55;
                                            zIndex = 20;
                                            width = "235px";
                                        } else {
                                            transform = "translateX(500px) scale(0.65)";
                                            opacity = 0;
                                            zIndex = 0;
                                        }

                                        return (
                                            <div
                                                key={screen.image}
                                                className="absolute left-1/2 -translate-y-1/2 transition-all duration-700 ease-out"
                                                style={{
                                                    width,
                                                    transform,
                                                    opacity,
                                                    zIndex
                                                }}
                                            >
                                                <div className={`overflow-hidden rounded-[32px] transition-shadow duration-700 ${isActive ? "shadow-[0_30px_80px_rgba(0,70,120,0.30)]" : "shadow-[0_20px_50px_rgba(0,70,120,0.15)]"}`}>
                                                    <img
                                                        src={screen.image}
                                                        alt={screen.title}
                                                        className="block h-auto w-full select-none"
                                                    />
                                                </div>

                                                {
                                                    isActive && (
                                                        <div className="absolute -bottom-12 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full border border-white/80 bg-white/90 px-5 py-2 text-sm font-semibold text-[#1685c4] shadow-lg backdrop-blur-md">
                                                            {screen.title}
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        );
                                    })
                                }
                            </div>

                            <div className="absolute inset-0 flex flex-col items-center justify-center lg:hidden">
                                <div className="relative w-[280px] sm:w-[320px]">
                                    <div className="overflow-hidden rounded-[30px] shadow-[0_30px_70px_rgba(0,70,120,0.28)]">
                                        <img
                                            src={appScreens[activeScreen].image}
                                            alt={appScreens[activeScreen].title}
                                            className="block h-auto w-full select-none"
                                        />
                                    </div>

                                    <div className="absolute -bottom-12 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full border border-white/80 bg-white/90 px-5 py-2 text-sm font-semibold text-[#1685c4] shadow-lg backdrop-blur-md">
                                        {appScreens[activeScreen].title}
                                    </div>
                                </div>
                            </div>

                            <div className="absolute bottom-2 left-1/2 -translate-x-1/2 lg:left-[64%] lg:translate-x-0 z-40 flex items-center gap-2 rounded-full border border-white/80 bg-white/70 px-4 py-2.5 shadow-md backdrop-blur-md">
                                {
                                    appScreens.map((screen, index) => (
                                        <button
                                            key={screen.image}
                                            type="button"
                                            onClick={() => setActiveScreen(index)}
                                            aria-label={`Show ${screen.title}`}
                                            className={`h-2 rounded-full transition-all duration-300 ${activeScreen === index ? "w-8 bg-[#1685c4]" : "w-2 bg-gray-300 hover:bg-gray-400"}`}
                                        />
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <GetStartedFreeTrial />
        </div>
    );
};

export default Home;